export const BankStatementOptions = {
  NET_BANKING: { title: "Net-Banking", value: "NET_BANKING" },
  BANK_GENERATED_PDF: { title: "Bank Generated PDF", value: "BANK_GENERATED_PDF" },
  PERFIOS_PDF: { title: "Bank Generated PDF for Automated Check", value: "PERFIOS_PDF" },
  SCANNER_UPLOAD: { title: "Use Scanner APP to upload", value: "SCANNER_UPLOAD" },
  GALLERY_UPLOAD: { title: "Upload from Gallery or use Camera", value: "GALLERY_UPLOAD" },
  NET_BANKING_SEND_LINK: { title: "Send Link to Customer", value: "NET_BANKING_SEND_LINK" },
  PERFIOS_UPLOAD_SEND_LINK: { title: "Send Link to Customer", value: "PERFIOS_UPLOAD_SEND_LINK" }
};

